import { Injectable, Inject } from '@angular/core';
import { Observable, of } from 'rxjs';
import { AuthenticationProvider, UserIdentity, SigninModel, OrganizationDto } from '../../../types';
import { HttpClient } from '@angular/common/http';

@Injectable()
export class FakeAuthenticationProviderService implements AuthenticationProvider {
    private user = new UserIdentity('Admin', 'LastName', ['/', 'p1', 'p2'], false, 1, 'org 1');

    constructor(private httpClient: HttpClient) {
    }

    changeUserPassword(currentPassword: string, newPassword: string): Observable<any> {
        // tslint:disable-next-line: max-line-length
        this.user = new UserIdentity('Admin', 'LastName', ['/', 'p1', 'p2'], false, this.user.activeOrganizationId, this.user.activeOrganizationTitle);
        return of(true);
    }

    signIn(signinModel: SigninModel) {
        console.log('FakeAuthProvider: Signed In.');
        return of(true);
    }

    getCaptcha(): Observable<Blob> {
        console.log('FakeAuthProvider: Captcha Retrived.');
        return this.httpClient.get('assets/template/img/fake-captcha.png', { responseType: 'blob' });
    }

    getUser(): Observable<UserIdentity> {
        return of(this.user);
    }

    getUserOrganizations(): Promise<OrganizationDto[]> {
        return of([
            {
                id: 1,
                title: 'Org1'
            },
            {
                id: 2,
                title: 'Org2'
            }
        ]).toPromise();
    }

    setUserOrganization(organizationId: number) {
        this.user = new UserIdentity('Admin', 'LastName', ['/', 'p1', 'p2'], this.user.forcePasswordChange, 1, 'Org1');
        return of(true);
    }

    refreshAuthToken(): Observable<any> {
        console.log('FakeAuthProvider: Token Refreshed.');
        return of(0);
    }

    signOut() {
        console.log('FakeAuthProvider: Signed Out.');
        return of(0);
    }
}
